import React, { useEffect, useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { ColumnContent, ColumnContentLarge, ColumnContentLargeTitle, ColumnContentSmall, ColumnContentSmallTitle } from 'styles/ColumnContent';
import { ContentList } from 'styles/Layout';
import { Container } from 'styles';
import LayoutContext from 'context/layout';
import Breadcrumb from 'components/layout/breadcrumb/Breadcrumb';
import ReturnButton from 'components/layout/return-button/ReturnButton';
import QuestionItem from 'components/layout/question-item/QuestionItem';
import SectionItem from 'components/layout/section-item/SectionItem';
import FaqService from 'services/faqService';
import Loading from 'components/layout/loading/Loading';
import { getCategoryLabel, getUrlCategoryType } from 'utils/appUtils';

const SectionPage = () => {
    const navigate = useNavigate();
    const { setState } = useContext(LayoutContext);
    const { id, type } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [sectionArticles, setSectionArticles] = useState([]);
    const [section, setSection] = useState();
    const [relatedSections, setRelatedSections] = useState([]);

    useEffect(() => {
		setState({ displaySearch: true, isHome: false });
        getRelatedSections();
        getArticleSections();
	}, []);

    useEffect(() => {
        getCurrentSection();
        getArticleSections();
	}, [id]);

    useEffect(() => {
        setCurrentActive();
	}, [section]);

    const getCurrentSection = () => {
        FaqService.getSection(id)
            .then(({ data }) => setSection(data))
    }

    const getRelatedSections = () => {
        const params = { size: 7 };
        const payload = { categoryType: getUrlCategoryType(type) };
        FaqService.getSections(params, payload)
            .then(({ data }) => setRelatedSections(() => data.content))
    }

    const getArticleSections = () => {
        setIsLoading(() => true);
        FaqService.getSectionArticles(id)
            .then(({ data }) => setSectionArticles(() => data.content))
            .catch(() => navigate('/'))
            .finally(() => setIsLoading(() => false))
    }

    const setCurrentActive = () => {
        if (relatedSections.length === 0) return;

        const index = relatedSections.findIndex(relatedSection => relatedSection.id === id);

        if (index > -1) {
            const current = relatedSections[index];
            const filtered = relatedSections.filter(relatedSection => relatedSection.id !== current.id);
            setRelatedSections([current, ...filtered]);
            return;
        }

        setRelatedSections([section, ...relatedSections]);
    }

	return (
		<>
            {isLoading ? (<Loading height="300px" />) : (
                <>
                    <Breadcrumb currentPageName={section?.name} />

                    <Container>
                        <ColumnContent>
                            <ColumnContentSmall showAfter>
                                <ColumnContentSmallTitle>{getCategoryLabel(type)}</ColumnContentSmallTitle>
                                <ContentList>
                                    {relatedSections.map((section, index) => <SectionItem key={section.id}  active={index === 0} id={section.id} name={section.name} type={section.categoryType} hideArrow />)}
                                </ContentList>

                                <ReturnButton />
                            </ColumnContentSmall>

                            <ColumnContentLarge>
                                <ColumnContentLargeTitle>{section?.name}</ColumnContentLargeTitle>

                                <ContentList>
                                    {sectionArticles.map(article => <QuestionItem key={article.id} url={article.url} title={article.title} type={article.categoryType} />)}
                                </ContentList>

                            </ColumnContentLarge>
                        </ColumnContent>
                    </Container>
                </>
            )}
		</>
	);
};

export default SectionPage;